import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {PermissionTypes} from '@iv/store/permissions/permissions.models';

@Component({
  selector: 'iv-live-common-calculator-header',
  templateUrl: './common-calculator-header.component.html',
  styleUrls: ['./common-calculator-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonCalculatorHeaderComponent {
  @Input() userPermissionMode: PermissionTypes;
  @Input() isFutures: boolean = false;
  @Input() isControlsShown: boolean = false;
  @Input() isEod: boolean = false;

  @Output() switchMode: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() switchType: EventEmitter<'options' | 'probability'> = new EventEmitter<'options' | 'probability'>();
  @Output() closeCalculator: EventEmitter<boolean> = new EventEmitter<boolean>();

  public type = 'options';

  readonly PermissionTypes = PermissionTypes;

  public onTypeChanged(type: 'options' | 'probability'): void {
    this.type = type;
    this.switchType.emit(type);
  }

  public onModeChanged(isEod: boolean): void {
    if (isEod !== this.isEod) {
      this.switchMode.emit(isEod);
      this.isEod = isEod;
    }
  }

  public close(): void {
    this.closeCalculator.emit(true);
  }
}
